import { ICustomProcessData } from "../components/Process";

const StatsArray = [
    {
        imagesrc: '/svgs/certified-icon.svg',
        alt: 'certifiedUsedCars',
        description: 'certifiedUsedCars',
        descs: 'certifiedUsedCarsSubtitle'
    },
    {
        imagesrc: '/svgs/inspection-point.svg',
        alt: 'inpectionsPoints',
        description: 'inpectionsPoints',
        descs: 'inpectionsPointsSubtitle'
    },
    {
        imagesrc: '/svgs/refund-icon.svg',
        alt: 'refundPolicy',
        description: 'refundPolicy',
        descs: 'refundPolicySubtitle'
    },
    {
        imagesrc: '/svgs/warranty-icon.svg',
        alt: 'warrentyTitle',
        description: 'warrentyTitle',
        descs: 'warrentySubtitles'
    }
];
export default StatsArray;

export const StatsArray2 = [
    {
        imagesrc: '/svgs/100inspection.svg',
        alt: '100+ inspection',
        descs: 'inspectionPoints'
    },
    {
        imagesrc: '/svgs/warranty6.svg',
        alt: 'refund',
        descs: 'warranties'
    },
    // {
    //     imagesrc: '/svgs/autofast.svg',
    //     alt: 'autofast',
    //     descs: 'maintenances'
    // },
    // {
    //     imagesrc: '/svgs/assitance.svg',
    //     alt: '1 year assistance',
    //     descs: 'assistance'
    // },
    {
        imagesrc: '/svgs/multicurrency.svg',
        alt: 'inspection',
        descs: 'multiCurrency'
    },
    {
        imagesrc: '/svgs/moneyback5.svg',
        alt: 'moneyback',
        descs: 'moneyBack'
    },
    {
        imagesrc: '/svgs/paperwork.svg',
        alt: 'paperWork',
        descs: 'paperWork'
    },
    {
        imagesrc: '/svgs/verify.svg',
        alt: 'verifyhistory',
        descs: 'verifyhistory'
    },
    {
        imagesrc: '/svgs/buy-back.svg',
        alt: 'buyBack',
        descs: 'buyBack'
    }
];

export interface IWhyAuto24 {
    imagesrc: string;
    alt: string;
    title: string;
    descs: string;
}

export const WHY_AUTO24_ARR: IWhyAuto24[] = [
    {
        imagesrc: '/images/auto24-insurance.webp',
        alt: 'certifiedUsedCars',
        title: 'certifiedUsedCars',
        descs: 'certifiedUsedCarsSubtitle'
    },
    {
        imagesrc: '/images/auto24-inspected.webp',
        alt: 'inpectionsPoints',
        title: 'inpectionsPoints',
        descs: 'inpectionsPointsSubtitle'
    },
    {
        imagesrc: '/images/auto24-refund.webp',
        alt: 'refundPolicy',
        title: 'refundPolicy',
        descs: 'refundPolicySubtitle'
    },
    {
        imagesrc: '/images/auto24-warranty.webp',
        alt: 'warrentyTitle',
        title: 'warrentyTitle',
        descs: 'warrentySubtitles'
    }
];

export const WHY_AUTO24_SELLPAGE_ARR: IWhyAuto24[] = [
    {
        imagesrc: '/images/saveTimeAndEffort.svg',
        alt: 'saveTimeAndEffort',
        title: 'saveTimeAndEffort',
        descs: 'saveTimeAndEffortSubtitle'
    },
    {
        imagesrc: '/images/freeNoCost.svg',
        alt: 'freeNoCost',
        title: 'freeNoCost',
        descs: 'freeNoCostSubtitle'
    },
    {
        imagesrc: '/images/competetivePrice.svg',
        alt: 'competetivePrice',
        title: 'competetivePrice',
        descs: 'competetivePriceSubtitle'
    }
];

export const HOW_IT_WORKS_SELLPAGE_ARR: ICustomProcessData[] = [
    {
        imagesrc: '/images/car.svg',
        title: 'carTitle',
        desc: 'carDesc'
    },
    {
        imagesrc: '/images/details.svg',
        title: 'personalDetail',
        desc: 'personalDetailDesc'
    },
    {
        imagesrc: '/images/cash.svg',
        title: 'sellCarHere',
        desc: 'sellCarHereDesc'
    },
] 